import { PagedListResponse, SuccessResponse, User, X5LessonSnapshot } from '../../../domain';
import { HttpPromiseState } from '../../../lib/helpers';
import { environment } from '../../../lib/environment';
import { httpClient } from '../../../domain/utils/httpClient';
import {
    Homework
} from '../homework-models';
import {
    StudentHomeworkListDto
} from '../../homeworkList/models/homeworkList-models';
import { AxiosRequestConfig } from 'axios';

class StudentHomeworkLoaders {
    getPendingHomeworks(request: StudentHomeworkListDto): HttpPromiseState<PagedListResponse<Homework>> {
        let url = `${environment.apiServer}/student/homework/pending`;
       
        return httpClient.state.post<PagedListResponse<Homework>>(url, request);       
    }


    getHomework(homeworkId: number): HttpPromiseState<Homework> {
        let url = `${environment.apiServer}/student/homework`;
        const cfg: AxiosRequestConfig = {
            params: { homeworkId }
        };
        return httpClient.state.get<Homework>(url, cfg);
    }

    getLessonSnapshot(homeworkId: number): HttpPromiseState<X5LessonSnapshot> {
        let url = `${environment.apiServer}/student/homework/lesson`;
        const cfg: AxiosRequestConfig = {
            params: { homeworkId }
        };
        return httpClient.state.get<X5LessonSnapshot>(url, cfg);
    }

    getLessonExamSnapshot(homeworkId: number): HttpPromiseState<X5LessonSnapshot> {
        let url = `${environment.apiServer}/student/homework/exam`;
        const cfg: AxiosRequestConfig = {
            params: { homeworkId }
        };
        return httpClient.state.get<X5LessonSnapshot>(url, cfg);
    }
    getExam(homeworkId: number): HttpPromiseState<Homework> {
        let url = `${environment.apiServer}/student/exam`;
        const cfg: AxiosRequestConfig = {
            params: { homeworkId }
        };
        return httpClient.state.get<Homework>(url, cfg);
    }

}

class HomeworkLoadersClass {
    readonly Student = new StudentHomeworkLoaders();
}

export const HomeworkLoaders = new HomeworkLoadersClass();
